import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { IconProps } from "../Facebook/FacebookIcon";

const TIKTOK_BRAND = "#fe2c55";

export const TiktokIcon = (props: IconProps) => {
  const { className, size = "1x", color } = props;

  return (
    <FontAwesomeIcon
      style={{
        // Rosa marca: visible en fondos claros y oscuros (evita "gray" o #000 en dark)
        color: color ?? TIKTOK_BRAND,
      }}
      icon={["fab", "tiktok"]}
      className={className}
      size={size}
    />
  );
};
